module.exports = __webpack_public_path__ + "img/logo_dark.7e08fa09.png";